
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar,
  },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      forceRender: 0,
      current: 0,
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
          y: {
            ticks: {
              display: false,
            },
            grid: {
              display: false,
            },
          },
          x: {
            min: 0,
            max: 90,
            ticks: {
              // Include a dollar sign in the ticks
              callback(value, index, ticks) {
                return value + '%'
              },
            },
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    }
  },
  mounted() {
    this.$gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.container,
        start: 'top bottom-=30%',
        // end: 'max',
        // markers: true,
        onEnter: () => {
          if (this.$isEmpty(this.chartData)) {
            this.chartData = {
              labels: this.blok.datasets[0]?.labels?.split(','),
              datasets: [
                {
                  label: 'Percent',
                  backgroundColor: this.blok.datasets[0]?.bar_color,
                  data: this.blok.datasets[0]?.data?.split(','),
                },
              ],
            }
          }
        },
      },
    })
  },
  methods: {
    updateCHart(chartData, index, event) {
      this.current = index

      const labels = chartData?.labels?.split(',')
      const backgroundColor = chartData?.bar_color
      const data = chartData?.data?.split(',')

      this.chartData = {
        labels,
        datasets: [
          {
            label: 'Percent',
            backgroundColor,
            data,
          },
        ],
      }

      const state = this.$Flip.getState(this.$refs.buttonShape?.[0])
      event.target.appendChild(this.$refs.buttonShape?.[0])

      this.$Flip.from(state, {
        absolute: true,
        duration: 0.5,
        ease: 'back(.5)',
      })
    },
  },
}
